const constants = {
    catalogue: {
        SEARCH_LIMIT: 24,
        SEARCH_OFFSET: 0,
    },
    filtre: {
        FILTRE_MOT_CLE: 1,
        FILTRE_DATE: 2,
        FILTRE_SAISON: 3,
        FILTRE_AGE: 4,
        FILTRE_PUBLIC: 5,
        FILTRE_HANDICAPE: 6,
        FILTRE_MOBILITE: 7,
        FILTRE_AUTONOMIE: 8,
        FILTRE_THEME: 9,
        FILTRE_LIEU_DEPART: 10,
        FILTRE_LIEU: 11,
        FILTRE_REGIONAL: 12,
        FILTRE_RYTHME: 13,
    },
    inscription: {
        MODE_INSCRIPTION_SEAGMA: 1,
        MODE_INSCRIPTION_EXTERNE: 2,
        MODE_INSCRIPTION_TEXTE: 3,
        MODE_INSCRIPTION_AUCUNE: 4,
        CONTINGENT_NORMAL: 1,
        CONTINGENT_PAYANT: 2,
        CONTINGENT_REDUCTION: 3,
        CONTINGENT_REDUCTION_MC: 1,
        QUESTION_TEXTE: 1,
        QUESTION_NOMBRE: 2,
        QUESTION_LISTE: 3,
        QUESTION_MULTIPLE: 4,
        PRIX_PAR_JOUR: 1,
        PRIX_PAR_PERIODE: 2,
        PRIX_PAR_INSCRIPTION: 3,
        TYPE_ACTIVITE_SEJOUR: 1,
        TYPE_ACTIVITE_PLAINE: 2,
        TYPE_ACTIVITE_FORMATION: 3,
        TYPE_ACTIVITE_ANIMATION: 4,
    },
    champs: {
        INDIVIDU_NOM: 'individu.nom',
        INDIVIDU_PRENOM: 'individu.prenom',
        INDIVIDU_NAISSANCE: 'individu.naissance',
        INDIVIDU_NRN: 'individu.nn',
        INDIVIDU_EMAIL: 'individu.email',
        INDIVIDU_TEL: 'individu.telephone',
        INDIVIDU_MOBILE: 'individu.gsm',
        INDIVIDU_SEXE: 'individu.sexe',
        INDIVIDU_LANGUE: 'individu.langue',
        INDIVIDU_NATIONALITE: 'individu.nationalite',
        INDIVIDU_ADR_CONTACT_NOM: 'adresse_individu.contact_nom',
        INDIVIDU_ADR_CONTACT_PRENOM: 'adresse_individu.contact_prenom',
        INDIVIDU_ADR_PRINCIPALE: 'adresse_individu.def_principal',
        INDIVIDU_ADR_FACTURATION_NOM: 'adresse_individu.facturation_nom',
        INDIVIDU_ADR_FACTURATION_PRENOM: 'adresse_individu.facturation_prenom',
        INDIVIDU_ADR_FACTURATION: 'adresse_individu.def_facturation',
        INSCRIPTION_URGENCE_NOM: 'inscription.urgence_nom',
        INSCRIPTION_URGENCE_PRENOM: 'inscription.urgence_prenom',
        INSCRIPTION_URGENCE_TELEPHONE: 'inscription.urgence_telephone',
        INDIVIDU_ADR_URGENCE: 'adresse_individu.def_urgence',
        PERIODES_PLAINE: 'periode.plaine',
        PERIODES_FORMATION: 'periode.formation',
        EMBARQUEMENTS: 'inscription.embarquements',
        DEBARQUEMENTS: 'inscription.debarquements',
        QUESTIONS: 'inscription.questions',
        CONTINGENTS: 'inscription.contingents',
        REMARQUES_ADMIN: 'inscription.remarques_admin',
        REMARQUES_PEDA: 'inscription.remarques_peda',
        RESUME: 'inscription.resume',
        INSCRIPTION_MC: 'inscription.mc',
        PLACES: 'inscription.nb_places',
        BLOC_DEBITEUR: 'inscription.bloc_debiteur',
    },
    debiteur: {
        HANDICAP_LEGER: 9,
        HANDICAP_LOURD: 10,
        HANDICAP_VALIDE: 0,
        AGE_MAX_SANS_HANDICAP: 14,
        AGE_MAX_AVEC_HANDICAP: 21,
    }
}
export default constants;
